import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { useFirebase } from 'contexts/FirebaseContext';
import { deleteDoc, doc } from 'firebase/firestore';
import { EventOccasion } from 'models/EventOccasion';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface DeleteEventDialogProps {
  event: EventOccasion;
  open: boolean;
  onDeleteEvent?: (event: EventOccasion) => void;
  onClose?: (ev: React.MouseEvent) => void;
}

export function DeleteEventDialog(props: DeleteEventDialogProps) {
  const { t } = useTranslation();
  const db = useFirebase().db;

  const handleCloseDialog = (ev: React.MouseEvent) => {
    props.onClose?.(ev);
  };

  const handleDeleteEvent = async (ev: React.MouseEvent) => {
    props.onDeleteEvent?.(props.event);

    await deleteDoc(doc(db, 'events', props.event.id)).then(() => {
      handleCloseDialog(ev);
    });
  };

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle variant="h3">{t('deleteEvent', 'Delete Event?')}</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" gutterBottom>
          {props.event.name}
        </Typography>
        <Typography variant="body2">{new Date(props.event.date).toLocaleDateString()}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog}>{t('cancel', 'Cancel')}</Button>
        <Button onClick={handleDeleteEvent} color="error">
          {t('delete', 'Delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
